import { freeze } from 'icepick';
import { createSelector } from 'reselect';
import { ff } from '@atlassian/jira-feature-flagging';
import type { BoardPermissions } from '../../../model/board/board-types';
import {
	CAN_MANAGE_LABS,
	CAN_RANK_COLUMNS,
	CAN_EDIT_BOARD,
	CAN_RENAME_COLUMNS,
	CAN_CREATE_COLUMNS,
	CAN_CREATE_CARDS,
	CAN_DELETE_ISSUE,
	CAN_MANAGE_SPRINT,
	CAN_MANAGE_AUTOMATION,
	CAN_RELEASE,
	CAN_EDIT_ISSUE,
} from '../../../model/permission/permission-types';

import type { State } from '../../reducers/types';
import { getBoard } from '../software/software-selectors';

export const boardPermissionsSelector = (state: State): BoardPermissions =>
	getBoard(state).permissions;

export const getPermissionsSelector = createSelector([boardPermissionsSelector], (permissions) =>
	freeze({
		[CAN_EDIT_BOARD]: permissions.editBoardConfig,
		[CAN_RANK_COLUMNS]: permissions.editBoardConfig || false,
		[CAN_RENAME_COLUMNS]: permissions.editBoardConfig || false,
		[CAN_CREATE_COLUMNS]: permissions.editBoardConfig || false,
		[CAN_MANAGE_LABS]: false,
		[CAN_CREATE_CARDS]: permissions.createIssue || false,
		[CAN_EDIT_ISSUE]: permissions.editIssue || false,
		[CAN_DELETE_ISSUE]: permissions.deleteIssue,
		[CAN_MANAGE_SPRINT]: permissions.manageSprint,
		[CAN_MANAGE_AUTOMATION]: permissions.manageAutomation || false,
		[CAN_RELEASE]: permissions.canRelease || false,
	}),
);

export const isIncrementPlanningReadOnly = createSelector(
	[getPermissionsSelector],
	(permissions) => {
		if (!ff('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1-fast-follow-3')) {
			return false;
		}

		// User is read only if they don't have create cards permission
		return !permissions[CAN_CREATE_CARDS];
	},
);
